import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Statistics } from '@/models/statistics.model';
import statisticsService from '@/services/statistics.service';

import { onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2ScanCharts',
  setup(__props) {

const data = ref<Statistics[]>([]);

onMounted(async () => {
  const d = await statisticsService.userCo2Footprints();
  data.value = d;
});

return (_ctx: any,_cache: any) => {
  const _component_v_frappe_chart = _resolveComponent("v-frappe-chart")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "CO₂ Footprint", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("p", null, "This shows the amount of users in specific brackets of CO₂ footprint.", -1)),
      _createVNode(_component_v_frappe_chart, {
        type: "bar",
        labels: data.value.map((d) => d.label),
        data: [
        {
          name: data.value[0]?.stackedValues[0].label || '',
          values: data.value.map((d) => d.stackedValues[0].value),
        },
      ],
        height: 300,
        colors: ['orange']
      }, null, 8, ["labels", "data"])
    ]),
    _: 1
  }))
}
}

})